import { createContext } from 'react';

const CustomVestmapContext = createContext();

export default CustomVestmapContext;
